import {
  formatCompactMoneyDisplay,
  formatMoneyFullLabel,
  isCompactMoneyAmount,
} from "@/shared/lib/format-compact-money";
import {
  cn,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@devhop/ui";

type CompactMoneyAmountProps = {
  amount: number;
  locale?: string;
  currencyLabel?: string;
  className?: string;
  currencyClassName?: string;
};

export function CompactMoneyAmount({
  amount,
  locale = "lo-LA",
  currencyLabel = "ກີບ",
  className,
  currencyClassName = "font-medium text-lg",
}: CompactMoneyAmountProps) {
  const display = formatCompactMoneyDisplay(amount, locale);
  const compact = isCompactMoneyAmount(amount);

  const body = (
    <>
      {display}{" "}
      <span className={currencyClassName}>{currencyLabel}</span>
    </>
  );

  if (!compact) {
    return (
      <span className={cn("tabular-nums", className)}>{body}</span>
    );
  }

  const fullLabel = formatMoneyFullLabel(amount, locale, currencyLabel);

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={cn(
              "cursor-default tabular-nums underline decoration-dotted decoration-muted-foreground/50 underline-offset-4",
              className,
            )}
            tabIndex={0}
          >
            {body}
          </span>
        </TooltipTrigger>
        <TooltipContent className="tabular-nums">{fullLabel}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
